import { mapGetters, mapState } from 'vuex'

export default {
    methods: {
        async showSpinner (bool = true) {
            await this.$store.dispatch('A_SET_SPINNER', bool)
        }
    },
    computed: {
        ...mapGetters(['GET_SPINNER']),
        ...mapState(['spinner']),
        getSpinner () {
            return this.GET_SPINNER
        }
    }

}
